export interface TagDragPayload {
  graphable_tags: string;
  tiger_func: string;
}

function isTauri(): boolean {
  return typeof window !== "undefined" && "__TAURI_INTERNALS__" in window;
}

export async function startTagDrag(payload: TagDragPayload): Promise<void> {
  if (!isTauri()) return;
  const { invoke } = await import("@tauri-apps/api/core");
  await invoke("start_tag_drag", { payload });
}

export async function cancelTagDrag(): Promise<void> {
  if (!isTauri()) return;
  const { invoke } = await import("@tauri-apps/api/core");
  await invoke("cancel_tag_drag");
}

/**
 * Mouseup-side drop dispatcher. The source webview holds OS-level pointer
 * capture from mousedown to release, so the target never sees `mouseup` —
 * instead the source invokes this on its own mouseup with the cursor's
 * `screenX`/`screenY`. Rust finds which webview window contains that point
 * and emits a `tag-drop` event to that window with the active payload.
 *
 * `screen_x` / `screen_y` are CSS (logical) pixels.
 */
export async function dropTagAt(screen_x: number, screen_y: number): Promise<void> {
  if (!isTauri()) return;
  const { invoke } = await import("@tauri-apps/api/core");
  await invoke("drop_tag_at", { screenX: Math.round(screen_x), screenY: Math.round(screen_y) });
}
